module.exports = __webpack_public_path__ + "b8546da09989f56b631751a4ad5b0934.svg";